/* template */
<template><es-popup :show="show" position="center" custom-class="custom-class" @overlay-click="closePopup"><div class="description-popup"><div class="description-copywritting"><div class="description-title">便捷购票说明</div><div class="description-content"><span>1、我们会全力为您出票，如果出票结果受余票变动及购票人数等因素影响，无法保证100%购票成功 
            2、如果出票失败，票款及服务费会全部原路返还
            3、退票/改签需至车站窗口办理，不支持网上在线退改
            4、出票成功即享便捷购票服务，若退票，服务费不退还
            5、便捷购票，享7*24 小时预定服务
            6、因便捷购票线上无须核验身份，故无法提供除儿童票外的其他优惠票服务（学生、伤残、军人等），可正常出正价票
            7、便捷购票服务费不可使用优惠券抵扣</span></div></div><mpx-view @tap="closePopup" class="description-confirm">我知道了</mpx-view></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf369d19a"}'>
  .description-popup
    display flex
    flex-direction column
    justify-content space-between
    align-items center
    padding-top 20px
    box-sizing border-box
    height auto
    width 280px
    border-radius 15px
    background #fff
    .description-copywritting
      display flex
      flex-direction column
      border-bottom 0.5px solid rgba(0, 0, 0, 0.08)
      font-family PingFang SC
      .description-title
        height 20px
        font-size 20px
        font-weight 500
        line-height 20px
        text-align center
        margin-bottom 13px
      .description-content
        font-size 14px
        line-height 21px
        margin 0 20px 18.5px 20px
        letter-spacing 0px
        color #666666
    .description-confirm
      height 50px
      display: flex;
      justify-content center
      align-items: center;
      font-family PingFangSC-Regular
      color #666
      font-weight normal
      font-size 16px
      letter-spacing 0px

</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf369d19a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexf369d19a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexf369d19a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mf369d19a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexf369d19a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
